



















import {Component, Vue} from "vue-property-decorator";
import BaseOverview, {Loadable} from "@/resources/components/BaseOverview.vue";
import ProductionOrder from '@/app/models/ProductionOrder';

@Component({
    components: {
        "base-overview": BaseOverview,
    },
})
export default class Index extends Vue {
    async loadItems(loadable: Loadable) {
        loadable.loadItems(
            (await ProductionOrder.index(loadable.page, {project_id: this.$route.params.project})).data
        );
    }
}
